<template>
<div class="microphone_container">
  <div class="microphone_container_header_outer">
    <div class="microphone_container_header_inner" :style="{ height: barHeightForAudio }"></div>
  </div>
  <div class="microphone_container_middle_tray"></div>
  <div class="microphone_container_bottom_tray"></div>
</div>
</template>

<script>
export default {
  name: 'microphoneIcon',
  props: {
    barHeightForAudio: {
      type: String,
      default: '0%'
    }
  }
}
</script>

<style lang="scss" scoped>
.microphone_container {
  width: 20px;
  height: 20px;
  position: relative;
  transform: scale(1);
  .microphone_container_header_outer {
    width: 7px;
    height: 11px;
    background-color: #FFFFFF;
    border-radius: 3px;
    border: 1px solid #FFFFFF;
    overflow: hidden;
    position: absolute;
    left: 50%;
    top: 2px;
    transform: translateX(-50%);
    .microphone_container_header_inner {
      width: 100%;
      background-color: #3982FF;
      border-radius: 0 0 3px 3px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
  .microphone_container_middle_tray {
    width: 12px;
    height: 7px;
    border: 1px solid #FFFFFF;
    position: absolute;
    left: 50%;
    top: 8px;
    transform: translateX(-50%);
    border-top: none;
    border-radius: 0 0 8px 8px;
  }
  .microphone_container_bottom_tray {
    width: 1px;
    height: 3px;
    background: #FFFFFF;
    position: absolute;
    left: 50%;
    top: 14px;
    transform: translateX(-50%);
    &::before {
      content: "";
      width: 8px;
      height: 1px;
      background: #FFFFFF;
      border-radius: 1px;
      position: absolute;
      bottom: -1px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
